export const defaultButtonConfiguration = {
    radius: 0,
};
